import Loadable from 'react-loadable';

import { Loading } from '../../common/navigation';


const Students = Loadable({
    loader: () => import('./components/students'),
    loading: Loading,
  });


export const routes = [
    {
      path: '/new-students',
      exact: true,
      name: 'students',
      component: Students,
    },
  ];
  